module.exports = __webpack_public_path__ + "img/plumber.6871865e.png";